import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import closepayLogo from "../../assets/images/closepayLogo.png";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";

import Company from "../../core/models/company";
import { Link, useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { BrowserView, MobileView } from "react-device-detect";
import ConfirmationDataIntroWeb from "./confirmationDataIntroWeb";
import ConfirmationDataIntroMobile from "./confirmationDataIntroMobile";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ConfirmationDataIntro = () => {
  const gaEventTracker = useAnalyticsEventTracker("FirstLoginQuestion");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "First Login Question",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ConfirmationDataIntroWeb></ConfirmationDataIntroWeb>
      </BrowserView>
      <MobileView>
        <ConfirmationDataIntroMobile></ConfirmationDataIntroMobile>
      </MobileView>
    </>
  );
};

export default ConfirmationDataIntro;
